export default function removeFromArray(arr, item) {
    return arr.filter(i => i !== item);
}
